(function() {
    'use strict';

    angular
        .module('elogbooks')
        .config(Translations);

    function Translations($translateProvider) {
        $translateProvider.translations('en-gb', {
            EXPORTS: 'Exports',
            EXPORT_LIST: 'Exports',
            QUEUED_AT: 'Queued At',
            STARTED_AT: 'Started At',
            ENDED_AT: 'Ended At',
            QUEUE_TIME: 'Queue Time',
            TYPE: 'Type',
            RUN_TIME: 'Run Time',
            REQUESTED_ROWS: 'Requested Rows',
            TOTAL_ROWS: 'Total Rows',
            EXPORT_STATUS_QUEUED: 'Queued',
            EXPORT_STATUS_IN_PROGRESS: 'In Progress',
            EXPORT_STATUS_COMPLETED: 'Completed',
            EXPORT_STATUS_FAILED: 'Failed',
            EXPORT_STATUS_IN_PROGRESS_DELAYED: 'In Progress (Delayed)',

            //Export Types
            EXPORT_TYPE_STATUTORY_TYPE: 'Statutory Type',
            EXPORT_TYPE_SUMMARY_REPORT: 'Summary Report',
            EXPORT_TYPE_MONTHLY_REPORT: 'Monthly Report',
            EXPORT_TYPE_KPI_MONTHLY_REPORT: 'KPI Monthly Report',
            EXPORT_TYPE_ENGINEERING_RISK_REPORT: 'Engineering Risk Report',
            EXPORT_TYPE_SP_USAGE_REPORT: 'SP Usage Report',
            EXPORT_TYPE_RESIDENTIAL_LOCATION_REPORT: 'Residential Location Report',
            EXPORT_TYPE_ASSET_TYPE: 'Asset Type',
            EXPORT_TYPE_SERVICE_ROUTINE: 'Service Routine',
            EXPORT_TYPE_DOCUMENT_TYPE: 'Document Type',
            EXPORT_TYPE_OPENING_TIME: 'Opening Time',
            EXPORT_TYPE_PPM: 'PPM',
            EXPORT_TYPE_PPM_GAP_ANALYSIS: 'PPM Gap Analysis',
            EXPORT_TYPE_AUDIT_TREND: 'Audit Trend',
            EXPORT_TYPE_AUDIT_TREND_ANSWERS: 'Audit Trend Answers',
            EXPORT_TYPE_PORTFOLIO_COMPLIANCE_REPORT: 'Portfolio Compliance Report',
            EXPORT_TYPE_OUTSTANDING_KPI_REPORT: 'Outstanding KPI Report',
            EXPORT_TYPE_KPI_TREND: 'KPI Trend',
            EXPORT_TYPE_KPI_DATA: 'KPI Data',
            EXPORT_TYPE_SITE_ASSOCIATE_ACTIVITY: 'Site Associate Activity',
            EXPORT_TYPE_SITE_ASSOCIATES: 'Site Associates',
            EXPORT_TYPE_SITE_TENANT: 'Site Tenant',
            EXPORT_TYPE_SP_SUMMARY_REPORT: 'SP Summary Report',
            EXPORT_TYPE_SP_FEEDBACK_REPORT: 'SP Feedback Report',
            EXPORT_TYPE_OPERATIVE_PERFORMANCE_REPORT: 'Operative Performance Report',
            EXPORT_TYPE_FM_SITES: 'FM Sites',
            EXPORT_TYPE_APPROVAL_AGE: 'Approval Age',
            EXPORT_TYPE_CONTRACT: 'Contract',
            EXPORT_TYPE_JOB_GROUP: 'Job Group',
            EXPORT_TYPE_PERMISSIONS_OVERVIEW_USERS: 'Permissions Overview Users',
            EXPORT_TYPE_USER: 'User',
            EXPORT_TYPE_ROLE_USERS: 'Role Users',
            EXPORT_TYPE_JOB: 'Job',
            EXPORT_TYPE_QUOTE: 'Quote',
            EXPORT_TYPE_ACTION: 'Action',
            EXPORT_TYPE_SITE: 'Site',
            EXPORT_TYPE_SITE_NOTES: 'Site Notes',
            EXPORT_TYPE_SITE_QUOTE_THRESHOLDS: 'Site Quote Thresholds',
            EXPORT_TYPE_ADMIN_SITE: 'Admin Site',
            EXPORT_TYPE_TASK: 'Task',
            EXPORT_TYPE_TASK_FREQUENCIES: 'Task Frequencies',
            EXPORT_TYPE_ASSET: 'Asset',
            EXPORT_TYPE_SUB_ASSET: 'Sub Asset',
            EXPORT_TYPE_METER: 'Meter',
            EXPORT_TYPE_METER_READINGS: 'Meter Readings',
            EXPORT_TYPE_METER_READINGS_OPTIMA: 'Meter Readings Optima',
            EXPORT_TYPE_SITE_GROUP: 'Site Group',
            EXPORT_TYPE_SERVICE_PROVIDER: 'Service Provider',
            EXPORT_TYPE_FM_PPM_REQUIRING_APPROVAL: 'FM PPM Requiring Approval',
            EXPORT_TYPE_FM_JOBS_EXTENSION_REQUESTED_LIST: 'FM Jobs Extension Requested List',
            EXPORT_TYPE_FM_JOBS_EXTENSION_REQUESTED_DETAIL: 'FM Jobs Extension Requested Detail',
            EXPORT_TYPE_FM_QUOTES_EXTENSION_REQUESTED_LIST: 'FM Quotes Extension Requested List',
            EXPORT_TYPE_FM_QUOTES_EXTENSION_REQUESTED_DETAIL: 'FM Quotes Extension Requested Detail',
            EXPORT_TYPE_FM_PAPERWORK_FOR_REVIEW: 'FM Paperwork For Review',
            EXPORT_TYPE_FM_ESCALATED_TO_CLIENT: 'FM Escalated To Client',
            EXPORT_TYPE_SP_PRIORITIES_EXTENSION_REQUESTED: 'SP Priorities Extension Requested',
            EXPORT_TYPE_SP_JOB_EXTENSION_REQUESTED: 'SP Job Extension Requested',
            EXPORT_TYPE_SP_QUOTE_EXTENSION_REQUESTED: 'SP Quote Extension Requested',
            EXPORT_TYPE_KPI_SURVEY: 'KPI Survey',
            EXPORT_TYPE_WASTE_ENTRY: 'Waste Entry',
            EXPORT_TYPE_WASTE_TYPE: 'Waste Type',
            EXPORT_TYPE_TREATMENT_TYPE: 'Treatment Type',
            EXPORT_TYPE_LOCATION: 'Location',
            EXPORT_TYPE_DOWNLOAD_FILES: 'Download Files',
            EXPORT_TYPE_AUDIT: 'Audit',
            EXPORT_TYPE_JOB_LABOUR_LINE: 'Job Labour Line',
            EXPORT_TYPE_PATROL_POINTS: 'Patrol Points',
            EXPORT_TYPE_SP_PARTNERSHIPS: 'SP Partnerships',
            EXPORT_TYPE_IMPORT_LOG: 'Import Log SCD',
            EXPORT_TYPE_IMPORT_LOG_AVANTI: 'Import Log PCD (Avanti)',
            EXPORT_TYPE_AUTOMATED_OVERVIEW_REPORT: 'Automated Overview Report'
        });
    }
})();
